<template>
  <Button
    color="shade-white"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <Icon color="primary" left icon="$symbols-circle-check-outline" iconSize="small"/>
    <span class="primary--text" v-text="lc.label"/>
  </Button>
</template>

<script>
import { Button, Icon } from '@locaweb/design-system-vue'

export default {
  name: 'SetAsMainButton',
  components: {
    Button,
    Icon
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    lc () {
      return this.$lc('domains.manageDomain.domainCard.setAsMainButton')
    }
  }
}
</script>
